import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import './homework-completed-student-list.scss';
import { ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source';
import Loading from '../../common/loading/loading';
import HomeworkApi from '../../../apis/homework';
import Utility from '../../../utility/common-utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSpinner, faDownload } from '@fortawesome/free-solid-svg-icons';
let { Parser } = require('json2csv');



class HomeworkCompletedStudentList extends React.Component {

    state = {
        studentList: [{ _id: '1', name: "Sara", createdDate: "Date", mobileNumber: "8105853633", email: "Sara@gmail.com" },
        { _id: '2', name: "Sara", createdDate: "Date", mobileNumber: "8105853633", email: "Sara@gmail.com" },
        { _id: '3', name: "Sara", createdDate: "Date", mobileNumber: "8105853633", email: "Sara@gmail.com" },
        { _id: '4', name: "Sara", createdDate: "Date", mobileNumber: "8105853633", email: "Sara@gmail.com" },
        { _id: '5', name: "Sara", createdDate: "Date", mobileNumber: "8105853633", email: "Sara@gmail.com" }]
    }



    componentDidMount() {
        //console.log(this.props.homeworkId)
        this.getHomeworkCompletionReport()

    }

    getHomeworkCompletionReport(payload = {}) {
        this.setState({ isLoading: true })

        // if (payload.page) payload.page = 1
        // if (payload.page) payload.limit = this.limit
        // payload.type = this.props.type

        if (this.props.homeworkId) {
            payload.homeworkId = this.props.homeworkId
            payload.schoolId = this.props.schoolId
            payload.homeworkType = this.props.homeworkType
        }

        HomeworkApi.getHomeworkCompletionReportForMasterHomework(payload)
            .then(response => {
                console.log(response)
                this.setState({ homeworkCompletedStudentList: response.completedStudents, isLoading: false })

            }).catch(err => {
            })
    }


    onClickExport = () => {

        if (this.state.exporting) return

        this.setState({ exporting: true })
        console.log("Export")


        if (this.props.homeworkType === "HOMEWORK" || this.props.homeworkType === "HOMEWORK_SELF") {
            if (this.state.homeworkCompletedStudentList && this.state.homeworkCompletedStudentList.length > 0) {

                let homeworkCompletedStudentArray = this.state.homeworkCompletedStudentList

                console.log(homeworkCompletedStudentArray)

                let csvBuild = []
                for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                    let item = homeworkCompletedStudentArray[i]

                    let obj = {
                    }
                    if (item["name"]) {

                        if (item['name']) {
                            obj['STUDENT NAME'] = item['name']
                        }

                        if (item?.userCreatedDate) {
                            obj['REGISTRATION DATE'] = this.datePipe(item.userCreatedDate)
                        }

                        if (item?.finishTime) {
                            obj[`${this.props.schoolworkType === "STANDARD" || this.props.schoolworkType === "ADAPTIVE" ? "HOMEWORK" : "CLASSWORK"} COMPLETED DATE`] = this.datePipe(item.finishTime)
                        }

                        if (item["mobileNumber"]) {
                            obj['MOBILE NUMBER'] = item["mobileNumber"]
                        }

                         if (this.props.chapterTitle) {
                            obj[`CHAPTER NAME`] = this.props.chapterTitle
                        }


                        if (item["email"]) {
                            obj['EMAIL'] = item["email"]
                        }

                        if (item["homeworkNodeCount"]) {
                            obj['TOTAL ELO'] = item["homeworkNodeCount"]
                        }

                        if (item["firstAttemptNotClearedCount"]) {
                            obj['TOTAL NOT CLEARED ELO'] = item["firstAttemptNotClearedCount"]
                        }

                        if (item["gtOneAttemptClearedEloCount"]) {
                            obj['ATTEMPTED ELO'] = item["gtOneAttemptClearedEloCount"]
                        }

                        if (item["learningPercentage"]) {
                            obj['LEARNING PERCENTAGE'] = item["learningPercentage"]
                        }

                    }

                    csvBuild.push(obj)
                }
                let json2csvParser = new Parser();
                let csv = json2csvParser.parse(csvBuild);

                console.log(csv);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = 'completed_student_report_' + (new Date).toISOString() + '.csv';
                hiddenElement.click();

                this.setState({ exporting: false })

            } else {
                this.setState({ exporting: false })
            }
        }
        else if (this.props.homeworkType === "ASSESSMENT" || this.props.homeworkType === "ASSESSMENT_SELF") {
            if (this.state.homeworkCompletedStudentList && this.state.homeworkCompletedStudentList.length > 0) {

                let homeworkCompletedStudentArray = this.state.homeworkCompletedStudentList

                console.log(homeworkCompletedStudentArray)

                let csvBuild = []
                for (let i = 0; i < homeworkCompletedStudentArray.length; i++) {
                    let item = homeworkCompletedStudentArray[i]

                    let obj = {
                    }
                    if (item["name"]) {

                        if (item['name']) {
                            obj['STUDENT NAME'] = item['name']
                        }

                        if (item?.userCreatedDate) {
                            obj['REGISTRATION DATE'] = this.datePipe(item.userCreatedDate)
                        }

                        if (item?.finishTime) {
                            obj[`${this.props.schoolworkType === 'NORMAL' ? 'HOMEWORK' : "CLASSWORK"} COMPLETED DATE`] = this.datePipe(item.finishTime)
                        }

                        if (item["mobileNumber"]) {
                            obj['MOBILE NUMBER'] = item["mobileNumber"]
                        }

                        if (this.props.chapterTitle) {
                            obj[`CHAPTER NAME`] = this.props.chapterTitle
                        }

                        if (item["email"]) {
                            obj['EMAIL'] = item["email"]
                        }

                        if (item["totalMark"]) {
                            obj['TOTAL MARK'] = item["totalMark"]
                        }

                        if (item["markScored"]) {
                            obj['MARK SCORED'] = item["markScored"]
                        }

                        if (item["timeTaken"]) {
                            obj['TIME TAKEN'] = item["timeTaken"]
                        }


                    }

                    csvBuild.push(obj)
                }
                let json2csvParser = new Parser();
                let csv = json2csvParser.parse(csvBuild);

                console.log(csv);

                let hiddenElement = document.createElement('a');
                hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
                hiddenElement.target = '_blank';
                hiddenElement.download = 'completed_student_report_' + (new Date).toISOString() + '.csv';
                hiddenElement.click();

                this.setState({ exporting: false })

            } else {
                this.setState({ exporting: false })
            }
        }


    }

    datePipe(givenDate, isTime = true) {
        if (!givenDate) return "-"
        givenDate = new Date(givenDate).toString()
        const [day, month, date, year, time] = givenDate.split(' ')
        return `${date} ${month}, ${year} ${isTime ? time.substr(0, 5) : ""}`

    }



    getName(type) {
        if (type === 'STANDARD') {
            return 'Standard Homework'
        } else if (type === 'ADAPTIVE') {
            return 'Personalised Homework'
        } else if (type === 'STANDARD_CLASSWORK') {
            return 'Standard Classwork'
        } else if (type === 'ADAPTIVE_CLASSWORK') {
            return 'Personalised Classwork'
        } else if (type === 'NORMAL') {
            return 'Homework Assessment'
        } else if (type === 'CLASSWORK_ASSESSMENT') {
            return 'Classwork Assessment'
        }
    }




    render() {

        if (this.props.homeworkType === "HOMEWORK" || this.props.homeworkType === "HOMEWORK_SELF") {
            return (
                <>
                    {this.state.isLoading && <div ><Loading> </Loading></div>}

                    {!this.state.isLoading && <Modal className="student-detail-modal cw-custom-modal-for-master-homework" size="lg"
                        aria-labelledby="contained-modal-title-vcenter" centered isOpen={this.props.show} toggle={this.props.onClose}>
                        <div className='container1' >
                            <div className='item item1'>{this.getName(this.props.schoolworkType)} Completed Student Details : </div>
                            <div className='item item2'>
                                <span>
                                    {
                                        this.state.homeworkCompletedStudentList && this.state.homeworkCompletedStudentList.length > 0 ?
                                            <strong className="pr-4">
                                                {/* <span>{this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}</span> */}
                                                <button className='btn btn-primary btn-sm' onClick={() => { this.onClickExport() }}>
                                                    {
                                                        !this.state.exporting ? <span> <FontAwesomeIcon icon={faDownload} /> Export</span> :
                                                            <span>  <FontAwesomeIcon icon={faSpinner} spin />Exporting</span>
                                                    }
                                                </button>
                                            </strong>
                                            : ""
                                    }
                                </span>

                            </div>
                            <div className="item item3">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>

                        </div>



                        <ModalBody className="smooth-edge" >
                            <div className="homework-completed-student-list">
                                <div>
                                    <div id="table-scoll" className="table-responsive pt-2">
                                        <table className="table mb-0 align-items-center  bg-white">
                                            <thead>
                                                <tr>
                                                    <th className='border-top-none'>Student Name</th>
                                                    <th className='border-top-none'>Registration Date</th>

                                                    <th className='border-top-none'>{this.props.schoolworkType === "STANDARD" || this.props.schoolworkType === "ADAPTIVE" ? "Homework" : "Classwork"} Completed Date</th>
                                                    <th className='border-top-none'>Mobile Number</th>
                                                    <th className='border-top-none'>Email</th>
                                                    <th className='border-top-none'>{this.props.schoolworkType === "STANDARD" || this.props.schoolworkType === "ADAPTIVE" ? "Homework" : "Classwork"} Chapter Name</th>
                                                    <th className='border-top-none'>Total ELO's</th>
                                                    <th className='border-top-none'>Total Not Cleared ELO's</th>
                                                    <th className='border-top-none'>Attempted ELO's</th>
                                                    <th className='border-top-none'>Learning Percentage</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.homeworkCompletedStudentList?.length ? this.state.homeworkCompletedStudentList.map((item, index) => (

                                                        <tr key={item._id}>
                                                            <td>{item.name}</td>
                                                            <td>{item.userCreatedDate ? Utility.datePipe(item.userCreatedDate, false) : '-'}</td>
                                                            <td>{item.finishTime}</td>
                                                            <td>{item.mobileNumber}</td>
                                                            <td>{item.email}</td>
                                                            <td>{this.props.chapterTitle}</td>
                                                            <td>{item.homeworkNodeCount}</td>
                                                            <td>{item.firstAttemptNotClearedCount ? item.firstAttemptNotClearedCount : "-"}</td>
                                                            <td>{item.gtOneAttemptClearedEloCount ? item.gtOneAttemptClearedEloCount : '-'}</td>
                                                            <td>{item.learningPercentage ? `${item.learningPercentage}%` : '-'}</td>
                                                        </tr>
                                                    ))
                                                        : <tr><td colSpan="10" align='center' className='text-gray'>No Records found !</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </ModalBody>

                    </Modal >}

                </>
            );
        } else if (this.props.homeworkType === "ASSESSMENT" || this.props.homeworkType === "ASSESSMENT_SELF") {
            return (
                <>
                    {this.state.isLoading && <div ><Loading> </Loading></div>}

                    {!this.state.isLoading && <Modal className="student-detail-modal cw-custom-modal-for-master-homework" size="lg"
                        aria-labelledby="contained-modal-title-vcenter" centered isOpen={this.props.show} toggle={this.props.onClose}>
                        <div className='container1' >
                            <div className='item item1'>{this.getName(this.props.schoolworkType)} Completed Student Details : </div>
                            <div className='item item2'>
                                <span>
                                    {
                                        this.state.homeworkCompletedStudentList && this.state.homeworkCompletedStudentList.length > 0 ?
                                            <strong className="pr-4">
                                                {/* <span>{this.state?.meta?.count ? <strong >Total: {this.state?.meta?.count || 0}</strong> : ""}</span> */}
                                                <button className='btn btn-primary btn-sm' onClick={() => { this.onClickExport() }}>
                                                    {
                                                        !this.state.exporting ? <span> <FontAwesomeIcon icon={faDownload} /> Export</span> :
                                                            <span>  <FontAwesomeIcon icon={faSpinner} spin />Exporting</span>
                                                    }
                                                </button>
                                            </strong>
                                            : ""
                                    }
                                </span>

                            </div>
                            <div className="item item3">
                                <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                            </div>

                        </div>



                        <ModalBody className="smooth-edge" >
                            <div className="homework-completed-student-list">
                                <div>
                                    <div id="table-scoll" className="table-responsive pt-2">
                                        <table className="table mb-0 align-items-center  bg-white">
                                            <thead>
                                                <tr>
                                                    <th className='border-top-none'>Student Name</th>
                                                    <th className='border-top-none'>Registration Date</th>
                                                    <th className='border-top-none'>{this.props.schoolworkType === 'NORMAL' ? 'Homework' : "Classwork"} Completed Date</th>
                                                    <th className='border-top-none'>Mobile Number</th>
                                                    <th className='border-top-none'>Email</th>
                                                    <th className='border-top-none'>{this.props.schoolworkType === 'NORMAL' ? 'Homework' : "Classwork"} Chapter Name</th>
                                                    <th className='border-top-none'>Total Mark</th>
                                                    <th className='border-top-none'>Mark Scored</th>
                                                    <th className='border-top-none'>Time Taken</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.homeworkCompletedStudentList?.length ? this.state.homeworkCompletedStudentList.map((item, index) => (

                                                        <tr key={item._id}>
                                                            <td>{item.name}</td>
                                                            <td>{item.userCreatedDate ? Utility.datePipe(item.userCreatedDate, false) : '-'}</td>
                                                            <td>{item.finishTime ? Utility.datePipe(item.finishTime, true) : '-'}</td>
                                                            <td>{item.mobileNumber}</td>
                                                            <td>{item.email}</td>
                                                            <td>{this.props.chapterTitle}</td>
                                                            <td>{item.totalMark}</td>
                                                            <td>{item.markScored}</td>
                                                            <td>{item.timeTaken}</td>



                                                        </tr>
                                                    ))
                                                        : <tr><td colSpan="10" align='center' className='text-gray'>No Records found !</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </ModalBody>

                    </Modal >}

                </>
            );
        }


    }
}


export default HomeworkCompletedStudentList;